import { render, staticRenderFns } from "./SpecialtiesCompareDialog.vue?vue&type=template&id=0da9a292&scoped=true&"
import script from "./SpecialtiesCompareDialog.vue?vue&type=script&lang=js&"
export * from "./SpecialtiesCompareDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpecialtiesCompareDialog.vue?vue&type=style&index=0&id=0da9a292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da9a292",
  null
  
)

export default component.exports